import React from 'react';
import { Container } from '@/Components/ui/container';
import { Stack } from '@/Components/ui/layout';
import { Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Text } from '@/Components/ui/typography';
import { Button } from '@/Components/ui/button';
import { Card, CardContent } from '@/Components/ui/card';
import { cn } from '@/lib/utils';

export const JobSeekerSection = () => {
  return (
    <div className="my-20 px-6">
      <Container size="default">
        <Card className="rounded-3xl bg-white/2 backdrop-blur-md border border-white/10 p-[60px_40px]">
          <Stack spacing="xl">
            <Card className={cn(
              "rounded-2xl p-8 transition-all",
              "bg-gradient-to-br from-primary/10 to-[#50c598]/5"
            )}>
              <Inline spacing="xl" align="center" className="gap-[60px]">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/78b4faef2a1752af65b0fb31e29bbc8850a572dfeb29ad8819e289498b26a393?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
                  alt="" 
                  loading="lazy"
                  className="w-auto h-auto"
                />
                <Stack spacing="md" className="flex-1 min-w-[300px]">
                  <Heading 
                    level="h2" 
                    className="text-[32px] font-semibold tracking-tight mb-5 bg-gradient-to-r from-white to-[#e0e0e0] bg-clip-text text-transparent"
                  >
                    Looking for a job?
                  </Heading>
                  <Text size="base" className="text-muted-foreground leading-relaxed mb-8">
                    Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed. Odio at nulla dolor purus aliquam nec turpis a. Fringilla tellus egestas vitae vestibulum mollis commodo. Viverra mattis amet urna lacus quis ultrices duis et sit.
                  </Text>
                  <Button 
                    variant="default" 
                    className="inline-flex items-center gap-3 py-3.5 px-7 rounded-xl text-base font-medium transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-primary/30"
                  >
                    <span>Start Searching</span>
                    <img 
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/54ea6b02cefd3a08fe78217c11ec2eb28e0274c2b8b03787a0e1244ab4265d81?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
                      alt="" 
                      loading="lazy"
                      className="w-6 h-6 transition-transform group-hover:translate-x-1"
                    />
                  </Button>
                </Stack>
              </Inline>
            </Card>
            
            <Card className={cn(
              "rounded-2xl p-8 transition-all mt-10",
              "bg-gradient-to-br from-white/5 to-white/2"
            )}>
              <Inline spacing="xl" align="center" className="gap-[60px]">
                <img 
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/5e7b4f64b49eb95b2318e4dda613f8317c66d59463eb3df2fda8fabee477bd67?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
                  alt="" 
                  loading="lazy"
                  className="w-auto h-auto"
                />
                <Stack spacing="md" className="flex-1 min-w-[300px]">
                  <Heading 
                    level="h2" 
                    className="text-[32px] font-semibold tracking-tight mb-5 bg-gradient-to-r from-white to-[#e0e0e0] bg-clip-text text-transparent"
                  >
                    Looking for a Hiring?
                  </Heading>
                  <Text size="base" className="text-muted-foreground leading-relaxed mb-8">
                    Lorem ipsum dolor sit amet consectetur. Sed platea elementum in morbi quam sed. Odio at nulla dolor purus aliquam nec turpis a. Fringilla tellus egestas vitae vestibulum mollis commodo. Viverra mattis amet urna lacus quis ultrices duis et sit.
                  </Text>
                  <Button 
                    variant="outline" 
                    className="inline-flex items-center gap-3 py-3.5 px-7 rounded-xl text-base font-medium border-2 border-primary text-primary transition-all hover:-translate-y-0.5 hover:bg-primary/10"
                  >
                    <span>Start Hiring</span>
                    <img 
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/a6ba33fc65bc106d721d3421ad813dc037860f03f2b3e0fcae032452790abe29?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803" 
                      alt="" 
                      loading="lazy"
                      className="w-6 h-6 transition-transform group-hover:translate-x-1"
                    />
                  </Button>
                </Stack>
              </Inline>
            </Card>
          </Stack>
        </Card>
      </Container>
    </div>
  );
};
